import defaultCoin from '../assets/images/default_coin.png'
// export function getSizeUnit(num: number | string) {
//   let newNumber = typeof num == 'string' ? Number(num) : (num || 0)
//   if (newNumber > 1000 * 1000 * 1000 * 1000) {
//     return (newNumber / 1000 / 1000 / 1000 / 1000).toFixed(2) + 'T'
//   } else if (newNumber > 1000 * 1000 * 1000) {
//     return (newNumber / 1000 / 1000 / 1000).toFixed(2) + 'B'
//   } if (newNumber > 1000 * 1000) {
//     return (newNumber / 1000 / 1000).toFixed(2) + 'M'
//   } else if (newNumber > 1000) {
//     return (newNumber / 1000).toFixed(2) + 'K'
//   } else if (newNumber < 1) {
//     return desensitizeNumber(newNumber, 8)
//   } else {
//     return newNumber.toFixed(2)
//   }
// }


export function getSizeUnit(num: number | string) {
  let newNumber = typeof num == 'string' ? Number(num) : (num || 0)
  if (newNumber > 1000) {
    return (newNumber / 10000).toFixed(2) + '万'
  } else if (newNumber < 1) {
    return desensitizeNumber(newNumber, 8)
  } else {
    return newNumber.toFixed(2)
  }
}




//处理字符串保留前n位后m位
export function desensitizeString(str: string, n: number = 4, m: number = 6): string {
  if (str.length < n || !str) {
    return str
  }
  //获取指定长度的字符串
  let startStr = "";
  let endStr = "";
  for (let i = 0; i < str.length; i++) {
    if (i < n) {
      startStr += str[i];
    } else if (i >= str.length - m) {
      endStr += str[i];
    }
  }
  return startStr + "****" + endStr
}

//保留最大n位长度小数。如果最后一位为0,则去掉
export function desensitizeNumber(num: number, n: number = 8): string {
  return Number(num).toFixed(n).replace(/\.?0+$/, '')

}



export const getTokenLogoURL = (chainId: number | undefined, address: string) => {
  if (chainId === 8285) return `https://kswap.web3s.finance/tokenlist/assets/KTOTEST/${address}.png`
  if (chainId === 2559) return `https://kswap.web3s.finance/tokenlist/assets/KTOMAIN/${address}.png`
  if (chainId === 2643) return `https://kswap.web3s.finance/tokenlist/assets/NOSMAIN/${address}.png`
  return ''
}

export function getColor(num: number | string, type: string = '1'): string {
  let newNumber = typeof num == 'string' ? Number(num) : num
  if (newNumber > 0) {
    return type == '0' ? '#FF3A5A' : '#00C07B'
  } else if (newNumber < 0) {
    return type == '0' ? '#00C07B' : '#FF3A5A'
  } else {
    return '#BCC4D1'
  }
}


//获取交易对名称
// export function getPairName(info: any): Array<any> {
//   if (['NOS', "KTO"].includes(info.token0_symbol)) {
//     // return `${info.token1_symbol}/${info.token0_symbol}`
//     return [{
//       token:info.token0
//       symbol: info.token1_symbol
//     }, {

//     }]
//   } else {
//     //  return `${info.token0_symbol}/${info.token1_symbol}`
//   }
// }
export function transformData(data: any) {
  // 创建一个新对象来存储转换后的数据，避免直接修改原始对象
  const transformedData = { ...data };

  // 检查转换条件：token0_symbol 是否包含 "NOS" 或 "KTO"
  const token0Symbol = data.token0_symbol;
  const shouldSwap = token0Symbol && (token0Symbol.includes("NOS") || token0Symbol.includes("KTO")) && !["USDT"].includes(data.token1_symbol);

  if (shouldSwap) {
    // console.log(`条件满足：token0_symbol "${token0Symbol}" 包含 "NOS" 或 "KTO"。开始交换值。`);

    // 定义需要交换的键对
    const keysToSwap = [
      ["liquidity_token0", "liquidity_token1"],
      ["token0", "token1"],
      ["token0_decimals", "token1_decimals"],
      ["token0_symbol", "token1_symbol"],
      ["volume_24h_token0", "volume_24h_token1"],
      ["amount0_out","amount1_out"],
      ["amount0_in","amount1_in"]
      // 如果还有其他类似 pattern 的键，也可以添加到这里
    ];

    // 遍历键对并交换它们的值
    keysToSwap.forEach(([key0, key1]) => {
      // 确保两个键都存在于数据中才进行交换
      if (transformedData.hasOwnProperty(key0) && transformedData.hasOwnProperty(key1)) {
        const temp = transformedData[key0];
        transformedData[key0] = transformedData[key1];
        transformedData[key1] = temp;
        // console.log(`已交换 ${key0} 和 ${key1} 的值。`);
      } else {
        // console.warn(`警告：键对 "${key0}" 或 "${key1}" 不存在，跳过交换。`);
      }
    });
  } else {
    // console.log(`条件不满足：token0_symbol "${token0Symbol}" 不包含 "NOS" 或 "KTO"。不进行交换。`);
  }

  return transformedData;
}


//获取默认图片
export const loadDefaultImage = (e: any) => {
  e.currentTarget.src = defaultCoin
}

//时间格式化
export const formatTime = (time: any,showSecond:boolean = true) => {
  let date = new Date(time);
  // let year = date.getFullYear();
  // let month = date.getMonth() + 1;
  // let day = date.getDate();
  let hour = date.getHours();
  let minute = date.getMinutes();
  let second = date.getSeconds();
  //时分秒小于10补0
  let hourStr = hour < 10 ? '0' + hour : hour;
  let minuteStr = minute < 10 ? '0' + minute : minute;
  let secondStr = second < 10 ? '0' + second : second;
  if(showSecond){
    return `${hourStr}:${minuteStr}:${secondStr}`;
  }
  return `${hourStr}:${minuteStr}`;
}

//如果是正数前面加上+号，负数不需要加
export function formatChg(num: number | string): string {
  if (!num) return "0.00"
  return Number(num) > 0 ? `+${Number(num).toFixed(2)}` : `${Number(num).toFixed(2)}`
}
